// ?[REVISIT] move outside of utils folder
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { isProduction } from '../../environment';
import ErrorBoundary from '../../react/ErrorBoundary';
import { ShippingCurrencyModalTrigger } from '../../../templates/_shared/ui-components/ShippingCurrencyModal/ShippingCurrencyModalTrigger';

// Mount shipping-currency modal trigger in the footer
const targetElements = Array.from(document.querySelectorAll('[react-render-target="currency-selector"]'));
const render = () => {
  targetElements.forEach((element) => {
    ReactDOM.render(
      <StrictMode>
        <ErrorBoundary className="centered-message" key={isProduction ? undefined : new Date().toString()}>
          <ShippingCurrencyModalTrigger />
        </ErrorBoundary>
      </StrictMode>,
      element
    );
  });
};

export { render };

// // HMR
// if (process.env.NODE_ENV === 'development' && module?.hot) {
//   module.hot.accept();
// }
